<template>
    <div class="wrapper">
        <v-layout justify-center>
            <v-snackbar
                    v-model="notification"
                    :timeout="9000"
                    :color="notification_type"
                    :top="true"

            >
                {{ notification_message }}
                <v-btn
                        text
                        @click="notification = false"
                >
                    Close
                </v-btn>
            </v-snackbar>

            <v-container
                    grid-list-md text-xs-center
            >
                <v-layout row wrap pa-2>
                    <v-flex xs12 v-show="orders.length">
                        <h2>
                            {{ $t(customer.name) }}'s {{ $t('Checkout')}}
                        </h2>
                        <v-simple-table>
                            <thead>
                            <tr>
                                <th class="text-center">
                                    {{ $t('Date') }}
                                </th>
                                <th class="text-left">
                                    {{ $t('Product') }}
                                </th>
                                <th class="text-left">
                                    {{ $t('QTY') }}
                                </th>
                                <th class="text-left">
                                    {{ $t('PRICE') }}
                                </th>
                                <th class="text-left">
                                    {{ $t('Staff') }}
                                </th>
                                <th class="text-center">
                                    {{ $t('Actions') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="order in orders">
                                <td>
                                    {{ order.created_at  | formatDate }}
                                    <!-- TODO: change color if older than 24 hours and add text was tabbed -->
                                </td>
                                <td>
                                    {{ $t(order.product.category.name) }}
                                    {{ $t(order.product.name) }}
                                    <span v-if="order.attribute_value">
                                        - {{ order.attribute_value.name }}
                                    </span>
                                </td>
                                <td>
                                    {{ order.qty }}
                                </td>
                                <td>
                                    ¥{{ order.qty * order.price }}
                                </td>
                                <td class="text-center">
                                    {{ $t(order.staff.name) }}
                                </td>
                                <td class="text-center">
                                    <v-btn
                                            color="blue-grey darken-4"
                                            fab
                                            rounded
                                            small
                                            text
                                            @click="delete_order(order)"
                                    >
                                        <v-icon>
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </td>


                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td class="text-left">
                                    <strong>{{ $t('Total') }}: </strong>
                                </td>
                                <td>
                                   <strong>
                                       <span v-show="paid === 0">
                                           ¥{{ total_amount }}
                                       </span>
                                       <span v-show="paid > 0">
                                           ¥{{ default_total - paid }}
                                       </span>
                                   </strong>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="text-right">

                        </div>

                        <v-form>
                            <v-card class="px-4">
                                <v-flex xs12>
                                    <v-btn
                                            v-show="1 === 2"
                                            color="blue-grey darken-4"
                                            @click="add_payment_type"
                                            block
                                            text
                                    >
                                        <v-icon>
                                            mdi-plus-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </v-flex>

                                <v-flex xs12>
                                    <v-simple-table dense>
                                        <thead>
                                        <tr>
                                            <th class="text-left">
                                                {{ $t('Type') }}
                                            </th>
                                            <th class="text-left">
                                                {{ $t('Amount') }}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(pt, index) in payment.payment_types" :key="index">

                                            <td>
                                                <v-select
                                                        :disabled="true"
                                                        v-model="pt.type"
                                                        :items="payment_methods"
                                                        item-value="id"
                                                        item-text="name"
                                                        :label="$t('Payment Methods')"
                                                        required
                                                        :error-messages="checkSubType"
                                                        @input="$v.payment.payment_types.$touch()"
                                                        @blur="$v.payment.payment_types.$touch()"
                                                ></v-select>
                                            </td>
                                            <td>
                                                <v-text-field
                                                        v-model="pt.amount"
                                                        :label="$t('Amount')"
                                                        :disabled="pt.type === 7"
                                                        type="number"
                                                        required
                                                        :error-messages="checkSubAmount"
                                                        @input="rebase_total()"
                                                        @blur="rebase_total()"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-center" v-show="1 === 3">
                                                <v-btn
                                                        v-show="payment.payment_types.length > 1"
                                                        color="blue-grey darken-4"
                                                        @click="remove_payment_type(index)"
                                                        text

                                                >
                                                    <v-icon>
                                                        mdi-close-circle-outline
                                                    </v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>


                                </v-flex>
                            </v-card>


                        </v-form>

                    </v-flex>
                    <v-flex xs12>
                        <v-btn
                                color="blue-grey darken-4"
                                block
                                v-show="!orders.length"
                                :to="'/c-panel/staff'"
                        >
                            {{ $t('Login Screen') }}
                        </v-btn>
                    </v-flex>

                    <v-flex xs4>
                        <v-btn
                                color="blue-grey darken-4"
                                block
                                v-show="orders.length"
                                :to="'/c-panel/products/'+staff_id+'/'+customer_id"
                        >
                            {{ $t('GO BACK') }}
                        </v-btn>
                    </v-flex>
                    <v-flex xs4>
                        <v-btn
                                color="blue-grey darken-4"
                                block
                                v-show="orders.length"
                                @click="tab_order()"
                        >
                            {{ $t('TAB ORDER') }}
                        </v-btn>
                    </v-flex>

                    <v-flex xs4>
                        <v-btn
                                color="blue-grey darken-4"
                                block
                                v-show="orders.length"
                                @click="checkout()"
                        >
                            {{ $t('COMPLETE ORDER') }}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </div>
</template>
<style lang="scss" scoped>
    .table {
        width: 100%;

        tr {
            th {
                padding: 5px;
                border: 1px solid #454545;
            }

            td {
                padding: 0 5px;
                border: 1px solid #454545;
            }

        }
    }
</style>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        validations: {
            payment: {
                payment_types: {
                    $each: {
                        type: {
                            required,
                        },
                        amount: {
                            required,
                        }
                    }
                }
            }
        },
        components: {},
        data() {
            return {
                notification: false,
                notification_type: '',
                notification_message: '',
                orders: [],
                customer: {},
                customer_id: 0,
                staff_id: 0,
                show_flash: false,
                flash_type: 'success',
                flash_message: '',
                payment_methods: [
                ],
                payment: {
                    payment_types: [
                        {
                            type: 1,
                            amount: null
                        },
                        {
                            type: 2,
                            amount: null
                        },
                        {
                            type: 3,
                            amount: null
                        },
                        {
                            type: 4,
                            amount: null
                        },
                        {
                            type: 5,
                            amount: null
                        },
                        {
                            type: 7,
                            amount: null
                        },
                        // {
                        //     type: 6,
                        //     amount: null
                        // }
                    ]
                },
                total_amount:0,
                default_total:0,
                paid:0,
                overlay: false
            }
        },
        created() {
            this.staff_id = parseInt(this.$route.params.staff_id);
            this.customer_id = parseInt(this.$route.params.customer_id);
            this.load_orders();

            let language_id = localStorage.getItem('language_id');
            let language = 'en';
            if(language_id)
            {
                language = language_id;
            } else {
                let chinese_staff_ids = [3, 7, 8];
                if (chinese_staff_ids.includes(this.staff_id)) {
                    language = 'zh';
                }
            }
            this.$i18n.locale = language;

            this.payment_methods = [
                {
                    id: 1,
                    name: this.$t('Cash')
                },
                {
                    id: 2,
                    name: this.$t('WeChat')
                },
                {
                    id: 3,
                    name: this.$t('Alipay')
                },
                {
                    id: 4,
                    name: this.$t('Card')
                },
                {
                    id: 5,
                    name: this.$t('Managers Discount')
                },
                {
                    id: 7,
                    name: this.$t('Credit')
                },
            ]
        },
        computed: {
            checkSubType() {
                const errors = [];
                let self = this;
                for (let i = 0; i < this.payment.payment_types.length; i++) {
                    !self.$v.payment.payment_types.$each.$iter[i].type.required && errors.push('.payment_types. type is required.');
                    !self.$v.payment.payment_types.$each.$iter[i].type.required && errors.push('.payment_types. type is required.');
                }

                return errors;
            },
            checkSubAmount() {
                const errors = [];
                let self = this;
                for (let i = 0; i < this.payment.payment_types.length; i++) {
                    if (!self.$v.payment.payment_types.$each.$iter[i].amount.$dirty) return errors;
                    !self.$v.payment.payment_types.$each.$iter[i].amount.required && errors.push('payment. .amount is required.');
                }
                return errors;
            },
        },
        methods: {
            delete_order(item) {
                if (confirm('Are you sure you wish to delete this item from the order? ')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/staff/order-lines/' + item.id + '/').then((response) => {
                        console.log(response);
                        this.load_orders();
                        this.notification = true;
                        this.notification_message = 'Successfully deleted order line';

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            add_payment_type() {
                this.payment.payment_types.push(
                    {
                        type: null,
                        amount: null,
                    },
                )
            },
            remove_payment_type(index) {
                this.payment.payment_types.splice(index, 1);
            },
            rebase_total()
            {
                this.paid = 0;
                let self = this;
                this.payment.payment_types.forEach(function(o, i){
                    if(parseFloat(o.amount) && parseFloat(o.amount) > 0)
                    {
                        self.paid += parseFloat(o.amount);
                    }
                });
            },
            load_orders() {
                this.$http.get(this.$http.defaults.baseURL + '/staff/order-lines/?customer_id=' + this.customer_id + '&state=1')
                    .then((response) => {
                        console.log("LOADED");
                        console.log(response);
                        this.orders = response.data;
                        let self = this;
                        this.total_amount = 0;
                        this.default_total = 0;
                        this.orders.forEach(function(o,i){
                            self.total_amount += o.price;
                            self.default_total += o.price;
                        });
                        this.customer = this.orders[0].customer;
                        let pt = this.payment.payment_types.find(o => o.type === 7);
                        if(self.default_total < this.customer.credit.credit)
                        {
                            this.customer.credit.credit = self.default_total;
                        }
                        pt.amount = this.customer.credit.credit;
                        this.rebase_total();
                    })
                    .catch((error) => {
                        console.log("page error");
                        console.log(error);
                    });
            },
            tab_order() {
                if (confirm('Are you sure you want to set the order status to tabbed ? ')) {
                    let tab_data = {
                        customer_id: this.customer_id,
                        invoice_id: this.orders[0].invoice_id,
                        state: 2// 1. act, 2.tab, 3.complete,
                    };
                    this.overlay = true;

                    this.$http.patch(this.$http.defaults.baseURL + '/staff/checkout', tab_data)
                        .then((response) => {
                            this.show_flash = true;
                            this.flash_message = 'Successfully Added To Tabbed Orders';
                            this.flash_type = 'success';
                            this.orders = [];

                            this.$router
                                .push({path: '/c-panel/customers/' + this.staff_id + '/'})
                        })
                        .catch((error) => {
                            console.log("page error");
                            console.log(error);
                            this.overlay = false;
                        });

                }
            },
            checkout() {
                this.overlay = true;
                this.payment.payment_types.forEach(function(o, i){
                    if(!parseFloat(o.amount) || parseFloat(o.amount) < 1)
                    {
                        o.amount = 0;
                    }
                });

                this.$v.payment.payment_types.$touch();

                if (this.$v.payment.payment_types.$invalid) {
                    // console.log(this.$v);
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }

                let self = this;
                let sub_total = 0;
                this.payment.payment_types.forEach(function(o,i){
                    sub_total += parseFloat(o.amount);
                });

                if(sub_total < this.total_amount)
                {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'The payment is less than the total please check again {payment_total: '+sub_total+', total_order_amount: '+this.total_amount+'}';
                    return false;
                }
                if(sub_total > this.total_amount)
                {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'The payment is MORE than the total please check again {payment_total: '+sub_total+', total_order_amount: '+this.total_amount+'}';
                    return false;
                }

                this.$http.post(this.$http.defaults.baseURL + '/staff/checkout', {
                    customer_id: this.customer_id,
                    staff_id: this.staff_id,
                    payment_types: this.payment.payment_types
                })
                    .then((response) => {
                        this.show_flash = true;
                        this.flash_message = 'Successfully Checkout Out';
                        this.flash_type = 'success';
                        this.orders = [];
                        this.$router
                            .push({path: '/c-panel/customers/' + this.staff_id + '/'})
                    })
                    .catch((error) => {
                        console.log("page error");
                        console.log(error);
                        this.overlay = false;
                    });

            }
        }
    }
</script>
